import { HTTP_METHODS, MEMBERSHIP_DOMAIN_CHANNEL, MEMBERSHIP_DOMAIN_CLIENT_ID } from '../constants/apiConstants';

export const MEMBERSHIP_DOMAIN_QUERY = `
 query TravelHeader {
  membership(type: JWT_TOKEN) {
    demographics {
      firstName
      displayAccountNumber
      isTopCard
      product {
        productFamily
        cardArtCdnLink
        description
        isBasic
        productId
      }
    }
    accountToken
    loyalty {
      pointsBalance
      isPwpEligible
    }
  }
}
`;

export const membershipDomainHeaders = ({
  correlationId, locale,
}: { correlationId: string, locale: string }) => ({
  method: HTTP_METHODS.POST,
  credentials: 'include',
  headers: {
    'X-Correlation-Id': correlationId,
    'Content-Type': 'application/json',
    'X-Client-Id': MEMBERSHIP_DOMAIN_CLIENT_ID,
    'X-Channel': MEMBERSHIP_DOMAIN_CHANNEL,
    'X-Timestamp': `${Date.now()}`,
    'X-Locale': locale,
    'X-partner-code': locale === 'en-US' ? 'IZ-ONLINE' : 'EZREZ',
  },
});
